export {
  BANANA_PROGRESS_GAUGE_VIEWBOX_DEFAULT,
  BANANA_VIEWBOX_HEIGHT,
  BANANA_VIEWBOX_WIDTH,
  banana_progress_clip_width,
  banana_progress_from_questions,
  clamp,
  format_svg_number,
  format_viewbox,
  good_answers_from_data,
  normalise_viewbox,
  number_or_default,
  progress_from_data,
  source_text_from_data,
  source_url_from_data,
  source_viewbox_from_data,
  total_from_data,
} from "./banana_progress_gauge_core_base.js";
export {
  banana_progress_clip_points,
  boundary_options_from_data,
  normalise_trace_points,
} from "./banana_progress_gauge_core_trace.js";
export {
  color_layer_definitions_from_data,
  layer_colors_from_data,
  layer_style_from_data,
  normalise_banana_progress_gauge_config,
  normalise_hex_color,
  normalise_layer_colors_for_definitions,
  selected_layer_class_from_data,
} from "./banana_progress_gauge_core_colors.js";
export {
  apply_imported_svg_layer_styles,
  inject_source_svg,
} from "./banana_progress_gauge_core_svg.js";
